import * as Yup from 'yup';
import { getDefaultItemId } from 'src/components/formik-utils';

export const initialValues = (formik, item) => {
  if(!formik) return;
  const myId = getDefaultItemId(item);
  if(0 < myId){
    formik.setFieldValue('id', myId);
    formik.setFieldValue('carId', item.car?.id);
    formik.setFieldValue('checkinBy', item.checkinHint);
    formik.setFieldValue('checkoutBy', item.checkoutHint);
  }
};

export const validationSchema = () => {
  let schema = Yup.object();
  schema = schema.shape({
    isVerified: Yup.boolean(),

    smsField: Yup.string()
      .transform((val) => (val || '').trim())
      .nullable()
      .when('isVerified', {
        is: true,
        then: (schema) => schema.required('Nội dung tin nhắn phải có'),
        otherwise: (schema) => schema.nullable(),
      }),

    checkinBy: Yup.number()
      .transform((value, originalValue) =>
        String(originalValue).trim() === '' ? null : value
      )
      .nullable()
      .when('isVerified', {
        is: false,
        then: (schema) =>
          schema
            .required('Vui lòng chọn Giờ xe ra')
            .notOneOf([0], 'Vui lòng chọn giờ xe ra'),
        otherwise: (schema) => schema.nullable(),
      }),

    checkoutBy: Yup.number()
      .transform((value, originalValue) =>
        String(originalValue).trim() === '' ? null : value
      )
      .nullable()
      .when('isVerified', {
        is: false,
        then: (schema) =>
          schema
            .required('Vui lòng chọn Giờ xe về')
            .notOneOf([0], 'Vui lòng chọn Giờ xe về'),
        otherwise: (schema) => schema.nullable(),
      }),
    });
  return schema;
};

export const handleSubmitted = async (values, item, apiUpdate, apiSendTicket, apiUnsendTicket) => {  
  const myId = getDefaultItemId(item);
  if(myId === 0) return;

  if(values.isVerified){
    const json = {
      userId: item.contact?.id,
      reason: values.smsField,
      sourceId: myId,
      tmsId: myId,
      carId: item.car?.id,
    };
    await apiSendTicket(json);
  }else{
    const ticketId = item.ticket?.id;
    if(ticketId > 0){
      const json = {
        moduleType: 0,
        userId: item.contact?.id,
        ticketId: ticketId,
      };
      await apiUnsendTicket(json);
    }else{
      await apiUpdate(values);
    }
  }
};
